<template>
  <div id="obituary-wreath-list" @click="close">
    <div class="modal" @click.stop>
      <div class="close" @click="close">
        <!-- <v-icon>mdi-close-circle-outline</v-icon> -->
        <span>닫기</span>
      </div>
      <div class="title">
        <h4>근조화환 추모하신 분</h4>
      </div>
      <div class="scroll-container">
        <v-sheet
          v-for="(wreath, idx) in obituaryWreath"
          :key="idx"
          class="msg-card py-3 px-4 mt-3"
          style="
            display: flex;
            width: 100%;
            height: auto;
            border: 1px solid #dadada;
            border-radius: 12px;
          "
        >
          <img
            src="../../assets/images/obituary/flower-photo.png"
            alt=""
            class="msg-card-flower-img"
          />
          <div>
            <h6 class="line-clamp" style="font-size: 14px; font-weight: 700">
              {{ wreath.NAME }}
            </h6>
            <p class="line-clamp" style="color: #555555">
              {{ wreath.COMMENT_NO }}
            </p>
          </div>
        </v-sheet>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    obituaryWreath: {
      type: Array,
      default: Array,
    },
  },
  data() {
    return {
      model: 0,
    };
  },
  computed: {},
  mounted() {},
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style>
.scroll-container {
  overflow-y: auto;
  max-height: 440px;
}
</style>
